import { useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../home/components/Footer';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import SubscriptionModal from './components/SubscriptionModal';

export default function ResourcesPage() {
  const [activeTab, setActiveTab] = useState('文档');
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    const siteUrl = import.meta.env.VITE_SITE_URL || 'https://documogul.com';
    
    document.title = '学习资源中心 - 技术文档、视频教程、博客文章 | 星允信息';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', '星允信息学习资源中心提供丰富的PDF技术文档、视频教程和专业博客文章，包括Adobe PDF Library SDK开发指南、PDF转换器用户手册、安全最佳实践等，助您深入了解PDF技术。');
    }

    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'PDF技术文档,视频教程,博客文章,开发指南,用户手册,学习资源,技术支持');
    }

    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', `${siteUrl}/resources`);

    const structuredData = {
      "@context": "https://schema.org",
      "@type": "CollectionPage",
      "name": "学习资源中心 - 星允信息",
      "description": "丰富的技术文档、视频教程和专业博客，助您深入了解PDF技术",
      "url": `${siteUrl}/resources`
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(structuredData);
    document.head.appendChild(script);

    return () => {
      if (document.head.contains(script)) {
        document.head.removeChild(script);
      }
    };
  }, []);

  const tabs = ['文档', '视频教程', '博客文章', '公告'];

  const documents = [
    {
      title: 'Adobe PDF Library SDK 开发指南',
      description: '完整的SDK开发文档，包含API参考、代码示例和最佳实践，帮助开发者快速上手PDF应用开发。',
      type: '技术文档',
      pages: '256页',
      format: 'PDF',
      size: '12.5 MB',
      icon: 'ri-file-code-line',
      bgColor: 'bg-teal-100',
      textColor: 'text-teal-600',
      downloadUrl: '#'
    },
    {
      title: 'PDF转换器用户手册',
      description: '详细介绍PDF转换器的功能特性、使用方法和常见问题解答，适合所有用户阅读。',
      type: '用户手册',
      pages: '89页',
      format: 'PDF',
      size: '5.2 MB',
      icon: 'ri-book-open-line',
      bgColor: 'bg-cyan-100',
      textColor: 'text-cyan-600',
      downloadUrl: '#'
    },
    {
      title: 'PDF安全最佳实践',
      description: '涵盖PDF文档加密、数字签名、权限管理等安全功能的详细说明和实施建议。',
      type: '技术文档',
      pages: '124页',
      format: 'PDF',
      size: '8.7 MB',
      icon: 'ri-shield-check-line',
      bgColor: 'bg-emerald-100',
      textColor: 'text-emerald-600',
      downloadUrl: '#'
    },
    {
      title: 'API集成快速入门',
      description: '5分钟快速集成指南，包含常用API调用示例和故障排除技巧。',
      type: '快速入门',
      pages: '32页',
      format: 'PDF',
      size: '2.1 MB',
      icon: 'ri-rocket-line',
      bgColor: 'bg-teal-100',
      textColor: 'text-teal-600',
      downloadUrl: '#'
    }
  ];

  const videos = [
    {
      title: 'PDF Library SDK 入门教程',
      description: '从零开始学习如何使用PDF Library SDK进行应用开发，包含环境搭建和基础功能实现。',
      duration: '45分钟',
      level: '初级',
      views: '12.5K',
      thumbnail: 'https://public.readdy.ai/ai/img_res/bf0788d461f86d258d360e886823dd2c.jpg',
      videoUrl: '#'
    },
    {
      title: '高级PDF处理技巧',
      description: '深入讲解PDF文档的高级处理技术，包括批量处理、性能优化和复杂场景应用。',
      duration: '1小时20分钟',
      level: '高级',
      views: '8.3K',
      thumbnail: 'https://readdy.ai/api/search-image?query=Advanced%20PDF%20processing%20tutorial%20showing%20complex%20document%20manipulation%20and%20batch%20processing%20workflow%20visualization%20on%20light%20beige%20background%2C%20performance%20optimization%20graphs%20and%20metrics%20display%2C%20professional%20technical%20training%20video%20with%20teal%20and%20cyan%20accents%2C%20modern%20clean%20design&width=600&height=400&seq=video-advanced-res2&orientation=landscape',
      videoUrl: '#'
    },
    {
      title: 'PDF表单自动化实战',
      description: '通过实际案例演示如何实现PDF表单的智能识别、数据提取和自动化处理。',
      duration: '55分钟',
      level: '中级',
      views: '15.2K',
      thumbnail: 'https://readdy.ai/api/search-image?query=PDF%20form%20automation%20tutorial%20showing%20intelligent%20form%20recognition%20and%20data%20extraction%20process%20on%20light%20gray%20background%2C%20automated%20workflow%20demonstration%20with%20business%20forms%2C%20professional%20training%20video%20with%20emerald%20green%20and%20teal%20accents%2C%20clean%20minimalist%20design&width=600&height=400&seq=video-forms-res3&orientation=landscape',
      videoUrl: '#'
    },
    {
      title: 'PDF安全与加密实践',
      description: '详细讲解PDF文档的安全保护措施，包括加密算法、数字签名和权限控制的实现方法。',
      duration: '38分钟',
      level: '中级',
      views: '9.7K',
      thumbnail: 'https://readdy.ai/api/search-image?query=PDF%20security%20and%20encryption%20tutorial%20showing%20digital%20signature%20process%20and%20encryption%20methods%20on%20light%20background%2C%20cybersecurity%20concepts%20visualization%20with%20lock%20and%20shield%20symbols%2C%20secure%20document%20protection%20demonstration%2C%20professional%20security%20training%20video%20with%20teal%20and%20cyan%20colors&width=600&height=400&seq=video-security-res4&orientation=landscape',
      videoUrl: '#'
    }
  ];

  const blogArticles = [
    {
      id: 0,
      title: '保护您的PDF：阻止AI模型抓取您的数据',
      excerpt: '随着生成式AI技术的快速发展，AI模型能够搜索和使用PDF中的内容进行训练。本文深入探讨如何保护您的PDF文档，防止未经授权的AI数据抓取。',
      category: '数据安全',
      date: '2026年1月14日',
      readTime: '16分钟',
      image: 'https://cdn.builder.io/api/v1/image/assets%2F239ec180664843638f6cce1510bb5d74%2F6c59df9d4b1f4821a3eb3dfb07301582',
      articleUrl: '/blog-ai-scraping-pdfs'
    },
    {
      id: 1,
      title: '何时选用 Adobe PDF Converter SDK',
      excerpt: '对于有高吞吐量、高精度 PDF 生成需求的企业组织而言，Adobe PDF Converter SDK 提供了一款专为 OEM 工作流打造的高性能、可定制化引擎。深入了解何时选用这款强大的工具包。',
      category: '产品指南',
      date: '2026年2月5日',
      readTime: '12分钟',
      image: 'https://static.readdy.ai/image/8dfcde88d6d872f7d495e2c3222a324c/e7a9e8d43515296761433a1383b90605.jpeg',
      articleUrl: '/blog-pdf-converter-sdk'
    },
    {
      id: 2,
      title: '2025年PDF技术趋势：AI视角下的行业洞察',
      excerpt: '我们向四个主流AI大语言模型询问了PDF的未来。它们的答案高度一致：PDF不是在消亡，而是正在成为数字基础设施的核心组成部分。',
      category: '行业趋势',
      date: '2026年1月30日',
      readTime: '12分钟',
      image: 'https://pdfa.org/wp-content/uploads/2025/12/ChatGPT-Image-Dec-19-2025-12_41_02-PM.png',
      articleUrl: '/blog-pdf-trends-2025'
    },
    {
      id: 3,
      title: 'PDF表单扁平化：技术原理与最佳实践',
      excerpt: '深入探讨PDF表单扁平化的技术原理、应用场景和实现方法。从AcroForm到XFA表单，全面解析如何将可编辑表单转换为静态内容，确保文档安全性和一致性。',
      category: '技术深度',
      date: '2026年2月1日',
      readTime: '14分钟',
      image: 'https://static.readdy.ai/image/8dfcde88d6d872f7d495e2c3222a324c/3ffea5805a2e73d63987ff40e66be2a9.jpeg',
      articleUrl: '/blog-pdf-forms-flattening'
    },
    {
      id: 4,
      title: '利用容器化技术实现企业级PDF处理：pdfRest API工具包容器深度解析',
      excerpt: '深入探讨如何利用容器化技术构建企业级PDF处理系统，以及pdfRest API工具包容器如何帮助企业实现这一目标。',
      category: '技术架构',
      date: '2025年1月31日',
      readTime: '10分钟',
      image: 'https://static.readdy.ai/image/8dfcde88d6d872f7d495e2c3222a324c/6fdb1f4518c2670df7c8eb8427cd9dfe.jpeg',
      articleUrl: '/blog-container-deployment'
    },
    {
      id: 5,
      title: 'Adobe PDF Converter在您应用中的强大功能',
      excerpt: '探索Adobe PDF Converter如何为您的应用程序提供强大的PDF转换功能，支持多种格式互转，提升文档处理效率。',
      category: '产品功能',
      date: '2025年1月29日',
      readTime: '8分钟',
      image: 'https://static.readdy.ai/image/8dfcde88d6d872f7d495e2c3222a324c/d5fc96e65b52f910aa0893c6ed2646ca.jpeg',
      articleUrl: '/blog-pdf-converter-application'
    },
    {
      id: 6,
      title: 'PDF/A标准与长期归档',
      excerpt: 'PDF/A是专为长期归档设计的PDF标准。本文介绍PDF/A的特点、应用场景以及如何生成符合标准的归档文档...',
      author: '赵敏',
      role: '文档管理专家',
      date: '2026年1月22日',
      readTime: '9分钟',
      category: '标准规范',
      image: 'https://readdy.ai/api/search-image?query=Document%20archiving%20blog%20header%20showing%20long-term%20digital%20preservation%20and%20PDF-A%20standard%20compliance%20on%20light%20background%2C%20archive%20management%20visualization%20with%20filing%20cabinets%20and%20documents%2C%20professional%20document%20management%20graphics%20with%20teal%20and%20cyan%20colors%2C%20minimalist%20design&width=600&height=400&seq=blog-archive-res6&orientation=landscape',
      articleUrl: '/blog-pdf-archive'
    },
    {
      id: 7,
      title: 'PDF表单数据提取实战',
      excerpt: '从PDF表单中准确提取数据是许多业务场景的核心需求。本文通过实际案例演示如何实现高效的表单数据提取...',
      author: '刘洋',
      role: '数据工程师',
      date: '2026年1月8日',
      readTime: '11分钟',
      category: '数据处理',
      image: 'https://readdy.ai/api/search-image?query=Data%20extraction%20blog%20header%20showing%20PDF%20form%20data%20being%20extracted%20and%20processed%20on%20light%20background%2C%20automated%20data%20flow%20visualization%20with%20arrows%20and%20tables%2C%20business%20intelligence%20graphics%20with%20charts%2C%20professional%20tech%20blog%20design%20with%20teal%20and%20cyan%20colors%2C%20clean%20modern%20style&width=600&height=400&seq=blog-extraction-res5&orientation=landscape',
      articleUrl: '/blog-form-extraction'
    },
    {
      id: 8,
      title: '云端PDF处理架构设计',
      excerpt: '随着云计算的普及，越来越多的企业选择将PDF处理迁移到云端。本文分享云端PDF处理系统的架构设计经验...',
      author: '陈强',
      role: '云架构师',
      date: '2025年12月18日',
      readTime: '10分钟',
      category: '架构设计',
      image: 'https://readdy.ai/api/search-image?query=Cloud%20architecture%20blog%20header%20showing%20PDF%20processing%20in%20cloud%20infrastructure%20on%20light%20background%2C%20distributed%20system%20design%20visualization%20with%20servers%20and%20data%20flow%20diagrams%2C%20cloud%20computing%20graphics%2C%20modern%20tech%20blog%20design%20with%20teal%20and%20cyan%20accents%2C%20minimalist%20style&width=600&height=400&seq=blog-cloud-res4&orientation=landscape',
      articleUrl: '/blog-cloud-architecture'
    },
    {
      id: 9,
      title: 'PDF表单字段识别与智能填充技术详解',
      excerpt: '深入探讨PDF表单字段识别的技术原理、实现方法以及最佳实践。从AcroForm到XFA表单，从字段识别到智能填充，全面解析表单自动化处理技术...',
      author: '刘洋',
      role: '数据工程师',
      date: '2025年11月15日',
      readTime: '15分钟',
      category: '技术深度',
      image: 'https://readdy.ai/api/search-image?query=Professional%20technical%20blog%20header%20showing%20PDF%20form%20field%20recognition%20technology%20with%20automated%20data%20extraction%20and%20intelligent%20form%20filling%20visualization%20on%20soft%20light%20gray%20background%2C%20modern%20AI%20and%20machine%20learning%20elements%20with%20digital%20forms%20and%20data%20flow%20diagrams%2C%20clean%20professional%20design%20with%20teal%20and%20cyan%20color%20accents%2C%20minimalist%20tech%20illustration%20style&width=600&height=400&seq=blog-form-field-res1&orientation=landscape',
      articleUrl: '/blog-form-field-recognition'
    },
    {
      id: 10,
      title: 'PDF安全：构建安全、合规且可扩展的PDF工作流',
      excerpt: '安全性是处理PDF文档时需要考虑的最重要因素之一。本文将讨论PDF的主要安全风险因素，以及开发人员如何有效保护其PDF工作流...',
      author: '王芳',
      role: '安全架构师',
      date: '2025年10月28日',
      readTime: '18分钟',
      category: '安全技术',
      image: 'https://readdy.ai/api/search-image?query=Cybersecurity%20blog%20header%20showing%20secure%20PDF%20workflow%20and%20document%20protection%20on%20light%20background%2C%20digital%20security%20shields%20and%20encryption%20symbols%20with%20lock%20icons%2C%20compliance%20and%20data%20protection%20visualization%2C%20professional%20security%20technology%20graphics%20with%20teal%20and%20cyan%20colors%2C%20clean%20modern%20minimalist%20design&width=600&height=400&seq=blog-pdf-security-res2&orientation=landscape',
      articleUrl: '/blog-pdf-security'
    },
    {
      id: 11,
      title: '如何选择合适的PDF开发工具',
      excerpt: '市面上有众多PDF开发工具，如何根据项目需求选择最适合的工具？本文将从功能、性能、成本等多个维度进行对比分析...',
      author: '张伟',
      role: '高级技术顾问',
      date: '2025年9月20日',
      readTime: '8分钟',
      category: '技术选型',
      image: 'https://readdy.ai/api/search-image?query=Professional%20blog%20article%20header%20showing%20PDF%20development%20tools%20comparison%20on%20light%20gray%20background%2C%20software%20selection%20decision%20making%20process%20visualization%2C%20technical%20evaluation%20charts%20and%20comparison%20tables%2C%20modern%20tech%20blog%20design%20with%20teal%20and%20cyan%20accents%2C%20clean%20minimalist%20style&width=600&height=400&seq=blog-tools-res1&orientation=landscape',
      articleUrl: '/blog-pdf-tools-selection'
    },
    {
      id: 12,
      title: 'PDF性能优化的10个技巧',
      excerpt: '在处理大量PDF文档时，性能往往成为瓶颈。本文分享10个实用的性能优化技巧，帮助您的应用运行得更快更稳定...',
      author: '李明',
      role: '性能优化专家',
      date: '2025年8月12日',
      readTime: '12分钟',
      category: '性能优化',
      image: 'https://readdy.ai/api/search-image?query=Performance%20optimization%20blog%20header%20with%20speed%20metrics%20and%20performance%20graphs%20on%20light%20background%2C%20fast%20document%20processing%20visualization%20with%20speedometer%20and%20charts%2C%20optimization%20techniques%20illustration%2C%20technical%20blog%20design%20with%20emerald%20green%20and%20teal%20colors%2C%20modern%20clean%20style&width=600&height=400&seq=blog-performance-res2&orientation=landscape',
      articleUrl: '/blog-pdf-performance'
    },
    {
      id: 13,
      title: 'PDF数字签名完全指南',
      excerpt: '数字签名是确保PDF文档真实性和完整性的的重要手段。本文详细介绍数字签名的原理、实现方法和最佳实践...',
      author: '王芳',
      role: '安全架构师',
      date: '2025年7月5日',
      readTime: '15分钟',
      category: '安全技术',
      image: 'https://readdy.ai/api/search-image?query=Digital%20signature%20blog%20header%20showing%20electronic%20signature%20process%20and%20certificate%20verification%20on%20light%20background%2C%20security%20and%20authentication%20visualization%20with%20digital%20certificate%20icons%2C%20professional%20cybersecurity%20graphics%20with%20teal%20and%20cyan%20colors%2C%20clean%20minimalist%20design&width=600&height=400&seq=blog-signature-res3&orientation=landscape',
      articleUrl: '/blog-timestamp-signatures'
    }
  ];

  const announcements = [
    {
      id: 2,
      title: '春节假期服务安排通知',
      content: '2026年春节假期期间（2月14日-2月28日），技术支持服务将调整为在线工单模式，紧急问题请通过24小时热线联系。',
      type: '服务通知',
      date: '2026年2月1日',
      isImportant: true,
      icon: 'ri-calendar-event-line'
    },
    {
      id: 1,
      title: 'Adobe PDF Library 安全公告 2026-JAN-APDFL18-1',
      content: '重要安全更新：Adobe PDF Library 18.1.19 版本发布，修复了多个安全漏洞，建议所有用户尽快升级。本次更新包含关键安全补丁和性能优化。',
      type: '安全公告',
      date: '2026年1月15日',
      isImportant: true,
      icon: 'ri-shield-check-line'
    },
    {
      id: 3,
      title: 'Adobe PDF Library服务公告 2025-DEC-APDFL18-1',
      content: 'Adobe PDF Library v18.0.5PlusP1x 现已发布！本版本新增表单验证API、增强PDF/A-3转换支持、添加批量水印功能，并修复了多个重要问题。',
      type: '产品更新',
      date: '2025年12月11日',
      isImportant: true,
      icon: 'ri-file-list-3-line'
    }
  ];

  const renderContent = () => {
    switch (activeTab) {
      case '文档':
        return (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {documents.map((doc) => (
              <div key={doc.title} className="bg-white rounded-xl shadow-lg p-8 hover:shadow-2xl transition-shadow">
                <div className="flex items-start mb-6">
                  <div className={`w-16 h-16 ${doc.bgColor} rounded-lg flex items-center justify-center mr-4`}>
                    <i className={`${doc.icon} text-3xl ${doc.textColor}`}></i>
                  </div>
                  <div className="flex-1">
                    <span className={`inline-block ${doc.bgColor} ${doc.textColor} px-3 py-1 rounded-full text-sm font-semibold mb-2`}>
                      {doc.type}
                    </span>
                    <h3 className="text-xl font-bold text-gray-900">{doc.title}</h3>
                  </div>
                </div>
                
                <p className="text-gray-600 mb-6 leading-relaxed">
                  {doc.description}
                </p>

                <div className="flex items-center justify-between text-sm text-gray-500 mb-6 pb-6 border-b border-gray-200">
                  <span className="flex items-center">
                    <i className="ri-file-line mr-1"></i>
                    {doc.pages}
                  </span>
                  <span className="flex items-center">
                    <i className="ri-file-pdf-line mr-1"></i>
                    {doc.format}
                  </span>
                  <span className="flex items-center">
                    <i className="ri-hard-drive-line mr-1"></i>
                    {doc.size}
                  </span>
                </div>

                <button className="w-full bg-teal-600 hover:bg-teal-700 text-white px-6 py-3 rounded-lg font-semibold transition-colors whitespace-nowrap cursor-pointer flex items-center justify-center">
                  <i className="ri-download-line mr-2"></i>
                  下载文档
                </button>
              </div>
            ))}
          </div>
        );

      case '视频教程':
        return (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {videos.map((video) => (
              <div key={video.title} className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-2xl transition-shadow">
                <div className="relative w-full h-64">
                  <img 
                    src={video.thumbnail}
                    alt={video.title}
                    className="w-full h-full object-cover object-top"
                  />
                  <div className="absolute inset-0 bg-black/40 flex items-center justify-center opacity-0 hover:opacity-100 transition-opacity cursor-pointer">
                    <div className="w-20 h-20 bg-white rounded-full flex items-center justify-center">
                      <i className="ri-play-fill text-4xl text-teal-600"></i>
                    </div>
                  </div>
                  <span className="absolute top-4 right-4 bg-black/75 text-white px-3 py-1 rounded-full text-sm">
                    {video.duration}
                  </span>
                </div>
                
                <div className="p-6">
                  <div className="flex items-center gap-2 mb-3">
                    <span className={`px-3 py-1 rounded-full text-sm font-semibold ${
                      video.level === '初级' ? 'bg-cyan-100 text-cyan-600' :
                      video.level === '中级' ? 'bg-teal-100 text-teal-600' :
                      'bg-emerald-100 text-emerald-600'
                    }`}>
                      {video.level}
                    </span>
                    <span className="text-sm text-gray-500 flex items-center">
                      <i className="ri-eye-line mr-1"></i>
                      {video.views}
                    </span>
                  </div>
                  
                  <h3 className="text-xl font-bold text-gray-900 mb-3">{video.title}</h3>
                  <p className="text-gray-600 mb-4 leading-relaxed">
                    {video.description}
                  </p>

                  <button className="w-full bg-teal-600 hover:bg-teal-700 text-white px-6 py-3 rounded-lg font-semibold transition-colors whitespace-nowrap cursor-pointer flex items-center justify-center">
                    <i className="ri-play-circle-line mr-2"></i>
                    观看视频
                  </button>
                </div>
              </div>
            ))}
          </div>
        );

      case '博客文章':
        return (
          <div className="space-y-8">
            {blogArticles.map((blog) => (
              <div key={blog.title} className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-2xl transition-shadow">
                <div className="flex flex-col md:flex-row">
                  <div className="w-full md:w-80 h-64">
                    <img 
                      src={blog.image}
                      alt={blog.title}
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                  
                  <div className="flex-1 p-8">
                    <div className="p-6">
                      <span className="bg-teal-100 text-teal-600 px-3 py-1 rounded-full text-sm font-semibold">
                        {blog.category}
                      </span>
                      <h3 className="text-xl font-bold text-gray-900 mt-4 mb-3 line-clamp-2">
                        {blog.title}
                      </h3>
                      <p className="text-gray-600 mb-4 line-clamp-2">
                        {blog.excerpt}
                      </p>
                      <div className="flex items-center justify-between">
                        <div className="flex items-center gap-4 text-sm text-gray-500">
                          <span className="flex items-center">
                            <i className="ri-calendar-line mr-1"></i>
                            {blog.date}
                          </span>
                          <span className="flex items-center">
                            <i className="ri-time-line mr-1"></i>
                            {blog.readTime}
                          </span>
                        </div>
                        <Link 
                          to={blog.articleUrl}
                          className="text-teal-600 hover:text-teal-700 font-semibold text-sm whitespace-nowrap cursor-pointer"
                        >
                          阅读全文 →
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        );

      case '公告':
        return (
          <div className="space-y-6">
            {announcements.map((announcement) => (
              <Link
                key={announcement.id}
                to={
                  announcement.id === 1 ? '/announcement-apdfl-security' : 
                  announcement.id === 2 ? '/announcement-holiday' :
                  '/announcement-service-bulletin'
                }
                className={`block bg-white rounded-xl shadow-lg p-6 hover:shadow-2xl transition-shadow ${
                  announcement.isImportant ? 'border-l-4 border-teal-500' : ''
                }`}
              >
                <div className="flex items-start gap-4">
                  <div className={`w-12 h-12 rounded-lg flex items-center justify-center flex-shrink-0 ${
                    announcement.isImportant ? 'bg-teal-100' : 'bg-gray-100'
                  }`}>
                    <i className={`${announcement.icon} text-2xl ${
                      announcement.isImportant ? 'text-teal-600' : 'text-gray-600'
                    }`}></i>
                  </div>
                  
                  <div className="flex-1">
                    <div className="flex items-center gap-3 mb-2 flex-wrap">
                      <span className={`px-3 py-1 rounded-full text-sm font-semibold ${
                        announcement.type === '产品更新' ? 'bg-teal-100 text-teal-600' :
                        announcement.type === '服务通知' ? 'bg-cyan-100 text-cyan-600' :
                        announcement.type === '安全公告' ? 'bg-red-100 text-red-600' :
                        announcement.type === '新功能' ? 'bg-emerald-100 text-emerald-600' :
                        announcement.type === '政策更新' ? 'bg-amber-100 text-amber-600' :
                        'bg-gray-100 text-gray-600'
                      }`}>
                        {announcement.type}
                      </span>
                      {announcement.isImportant && (
                        <span className="bg-red-500 text-white px-2 py-0.5 rounded text-xs font-semibold">
                          重要
                        </span>
                      )}
                      <span className="text-sm text-gray-500 flex items-center">
                        <i className="ri-calendar-line mr-1"></i>
                        {announcement.date}
                      </span>
                    </div>
                    
                    <h3 className="text-xl font-bold text-gray-900 mb-2">
                      {announcement.title}
                    </h3>
                    <p className="text-gray-600 leading-relaxed mb-3">
                      {announcement.content}
                    </p>
                    <span className="text-teal-600 hover:text-teal-700 font-semibold text-sm inline-flex items-center">
                      查看详情 <i className="ri-arrow-right-line ml-1"></i>
                    </span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        );

      default:
        return null;
    }
  };

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-teal-600 via-cyan-600 to-teal-700 text-white py-24">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="text-center" style={{ marginTop: '25px' }}>
            <h1 className="text-5xl lg:text-6xl font-bold mb-6">
              资源中心
            </h1>
            <p className="text-xl lg:text-2xl text-teal-100 max-w-3xl mx-auto mb-8">
              丰富的技术文档、视频教程和专业博客，助您深入了解PDF技术
            </p>
          </div>
        </div>
      </section>

      {/* Tab Navigation */}
      <section className="py-8 bg-gray-50 sticky top-0 z-10 shadow-sm">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="flex flex-wrap justify-center gap-3">
            {tabs.map((tab) => (
              <button
                key={tab}
                onClick={() => setActiveTab(tab)}
                className={`px-8 py-3 rounded-lg font-semibold transition-all whitespace-nowrap cursor-pointer ${
                  activeTab === tab
                    ? 'bg-teal-600 text-white shadow-lg'
                    : 'bg-white text-gray-700 hover:bg-gray-100'
                }`}
              >
                {tab}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          {renderContent()}
        </div>
      </section>

      {/* Newsletter Section */}
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center">
          <div className="bg-gradient-to-r from-teal-600 to-cyan-600 rounded-2xl p-12 text-white">
            <i className="ri-mail-line text-5xl mb-6"></i>
            <h2 className="text-3xl lg:text-4xl font-bold mb-4">
              订阅我们的资源更新
            </h2>
            <p className="text-xl text-teal-100 mb-8">
              第一时间获取最新的技术文档、教程和行业洞察
            </p>
            <div className="flex flex-col sm:flex-row gap-4 max-w-xl mx-auto">
              <input 
                type="email"
                placeholder="请输入您的邮箱地址"
                className="flex-1 px-6 py-4 rounded-lg text-gray-900 focus:outline-none focus:ring-2 focus:ring-teal-300"
              />
              <button 
                onClick={() => setIsModalOpen(true)}
                className="bg-white text-teal-600 px-8 py-4 rounded-lg font-semibold hover:bg-teal-50 transition-colors whitespace-nowrap cursor-pointer"
              >
                立即订阅
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto">
            <div className="bg-white rounded-xl p-8 text-center shadow-lg">
              <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-question-line text-3xl text-teal-600"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">需要帮助？</h3>
              <p className="text-gray-600 mb-6">查看我们的常见问题或联系技术支持</p>
              <a href="/contact" className="inline-block bg-teal-600 hover:bg-teal-700 text-white px-6 py-2 rounded-lg font-semibold transition-colors whitespace-nowrap cursor-pointer">
                联系我们
              </a>
            </div>

            <div className="bg-white rounded-xl p-8 text-center shadow-lg">
              <div className="w-16 h-16 bg-emerald-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-service-line text-3xl text-emerald-600"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">专业服务</h3>
              <p className="text-gray-600 mb-6">了解我们的专业咨询和定制开发服务</p>
              <a href="/services" className="inline-block bg-emerald-600 hover:bg-emerald-700 text-white px-6 py-2 rounded-lg font-semibold transition-colors whitespace-nowrap cursor-pointer">
                查看服务
              </a>
            </div>
          </div>
        </div>
      </section>

      <Footer />
      
      <SubscriptionModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </div>
  );
}
